import apiEndpoints from "./apiEndpoints";
import http from "./http";
import { withLang } from "./langParam";

export const welcomeBackApi = (key, userToken) => {
    try {
        return http.get(`${apiEndpoints.welcomeBackApi}?key=${key}&userId=${userToken}`);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const getkeyWordsApi = (data = '',) => {
    try {
        const url = data
            ? `${apiEndpoints.getkeyWords}?name=${data}`
            : apiEndpoints.getkeyWords;

        return http.get(url);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};


export const getVideosApi = ({ selectedCatgId = '', keyIds = [], searchValue, pageSize, pageNumber, userId }) => {
    try {
        if (selectedCatgId === 0) {
            selectedCatgId = '';
        }

        let url = apiEndpoints.getVideos;
        const queryParams = [];

        if (userId && userId != 'undefined') {

            queryParams.push(`userId=${encodeURIComponent(userId)}`);
        }
        queryParams.push(`PageSize=${encodeURIComponent(pageSize)}`);
        queryParams.push(`PageNumber=${encodeURIComponent(pageNumber)}`);
        if (searchValue) {
            queryParams.push(`searchName=${encodeURIComponent(searchValue)}`);
        }

        if (selectedCatgId) {
            queryParams.push(`categoryId=${encodeURIComponent(selectedCatgId)}`);
        }

        if (keyIds?.length > 0) {
            const subCategoryIdsQuery = keyIds
                .map(id => `keywordIds=${encodeURIComponent(id)}`)
                .join('&');
            queryParams.push(subCategoryIdsQuery);
        }

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        return http.get(withLang(url));
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const getVideoDetailApi = (id, userId) => {
    try {
        const query = userId ? `?userId=${userId}` : "";
        return http.get(withLang(`${apiEndpoints.getVideoDetail}/${id}${query}`));
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const getRelatedVideosApi = ({ categoryId, page, limit, vdoId, userId }) => {
    try {
        const queryParams = [];

        if (userId && userId != 'undefined') {
            queryParams.push(`userId=${encodeURIComponent(userId)}`);
        }

        if (page) {
            queryParams.push(`PageNumber=${encodeURIComponent(page)}`);
        }

        if (vdoId) {
            queryParams.push(`FilterVideoId=${encodeURIComponent(vdoId)}`);
        }

        if (limit) {
            queryParams.push(`PageSize=${encodeURIComponent(limit)}`);
        }

        const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

        return http.get(withLang(`${apiEndpoints.getVideoDetail}?categoryId=${encodeURIComponent(categoryId)}${queryString}`));
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

// DEPRECATED: Use VideoCatalogue.getVideosList() instead
// export const getAllVideosApi = (...) => { ... }



export const getCategoryApi = () => {
    try {
        return http.get(`${apiEndpoints.getAllCategory}`);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};


export const getUserId = (email) => {

    try {
        return http.get(`${apiEndpoints.getUser}?Email=${email}`);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
}


export const postCreateUserApi = (data) => {

    try {
        return http.post(`${apiEndpoints.postCreateUser}`, data);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const userBookMarkApi = (assetId, userId) => {
    try {
        // FIXED: Use JSON body format to match backend BookMarkPostCreate model
        const requestBody = {
            UserId: userId,
            VideoId: assetId
        };
        return http.post(`${apiEndpoints.postBookmark}`, requestBody);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};


export const removeBookMarkApi = (videoId, userId) => {
    try {
        // FIXED: Use JSON body format to match backend BookMarkPostCreate model
        const requestBody = {
            UserId: userId,
            VideoId: videoId
        };
        return http.delete(`${apiEndpoints.deleteBookMark}`, requestBody);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};


export const getUserBookMarkListApi = (page, limit, userId) => {
    try {
        return http.get(`${apiEndpoints.getBookMarkList}?userId=${userId}&PageNumber=${page}&PageSize=${limit}`);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
}

export const postInProgressApi = (assetId, userId) => {
    const values = {

        "userId": userId,
        "videoId": assetId

    }
    try {
        return http.post(`${apiEndpoints.postInprogress}`, values);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const getInProgressListApi = (userId) => {
    try {
        return http.get(`${apiEndpoints.getInProgressList}?userId=${userId}`);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
}

export const postCompletedApi = (assetId, userId) => {
    const values = {

        "userId": userId,
        "videoId": assetId

    }
    try {
        return http.post(`${apiEndpoints.postCompleted}`, values);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};


export const postVideoProgressApi = (videoId, percentWatched, secondsWatched) => {
    // User is derived server-side from the JWT — we intentionally send NO userId (spec §12.1).
    return http.postKeepalive(`${apiEndpoints.postVideoProgress}`, {
        videoId, percentWatched, secondsWatched,
    });
};


export const removefromCompletedApi = (videoId, userId) => {
    const values = {

        "userId": userId,
        "videoId": videoId

    }
    try {
        return http.delete(`${apiEndpoints.deleteCompleted}`, values);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};


export const getCompletedListApi = (page, limit, userId) => {
    try {
        const queryParams = [];
        if (page) {
            queryParams.push(`PageNumber=${encodeURIComponent(page)}`);
        }

        if (limit) {
            queryParams.push(`PageSize=${encodeURIComponent(limit)}`);
        }

        if (userId && userId != 'undefined') {
            queryParams.push(`userId=${encodeURIComponent(userId)}`);
        }
        const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

        return http.get(`${apiEndpoints.getCompletedList}${queryString}`);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};


export const postSaveKeywordsApi = (keyId, userId) => {

    const values = keyId
    try {
        return http.post(`${apiEndpoints.addKeywords}/${userId}`, values);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};


export const getSavedKeywordsApi = (userId) => {
    if (!userId || userId === "undefined") {
        return Promise.resolve({ data: [] });
    }

    const url = `${apiEndpoints.getSavedKeywords}?userId=${encodeURIComponent(userId)}`;
    return http.get(url).catch(error => {
        return Promise.reject(error?.response?.data || error);
    });
};


export const deleteKeywordsApi = (keyId, userId) => {

    const values = {

        "userId": userId,
        "keyWordId": keyId

    }

    try {
        return http.delete(`${apiEndpoints.deleteKeywords}`, values);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
}


export const updateProfilePicApi = (pic, userId) => {
    const formData = new FormData();
    formData.append("ProfilePic", pic);
    formData.append("userId", userId)

    try {
        return http.postFormData(`${apiEndpoints.updateProfilePic}`, formData);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const getProfilePicApi = (userId) => {


    try {
        return http.get(`${apiEndpoints.updateProfilePic}?userId=${userId}`);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

// DEPRECATED: Use VideoCatalogue.getVideosList() instead
// export const getAllVideosApis2 = (...) => { ... }

// DEPRECATED: Use VideoCatalogue.getVideosByCategory() instead
// export const getVideosApis2 = (...) => { ... }


export const getAllBlogs = ({ categoryId, userToken, searchTitle = "" }) => {
    try {
   
        let url = apiEndpoints.getBlogsApis;
        const queryParams = [];

        if (searchTitle && searchTitle != 'undefined') {

            queryParams.push(`searchValue=${encodeURIComponent(searchTitle)}`);
        }


        if (userToken && userToken != 'undefined') {

            queryParams.push(`userId=${encodeURIComponent(userToken)}`);
        }

        if (categoryId) {
            queryParams.push(`categoryId=${encodeURIComponent(categoryId)}`);
        }

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }
        return http.get(withLang(url));
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const getBookMarkedBlogsApi = (userId) => {
    const values = {
        "userId": userId
    }
    try {
        return http.get(`${apiEndpoints.getbookmarkblog}?userId=${userId}`);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const blogBookMarkApi = (assetId, userId) => {

    try {
        return http.post(`${apiEndpoints.bookmarkblog}?userId=${userId}&blogId=${assetId}`);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const postBlogDwellApi = (blogId, dwellSeconds, scrollPercent) => {
    // User derived server-side from the JWT — no userId sent (spec §12.1).
    return http.postKeepalive(`${apiEndpoints.postBlogDwell}`, {
        blogId, dwellSeconds, scrollPercent,
    });
};

export const removeBlogBookMarkApi = (blogId, userId) => {
    try {
        return http.delete(
            `${apiEndpoints.removebookmarkblog}?userId=${userId}&blogId=${blogId}`
        );
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};


export const filterAllblogs = ({


    selectedCatgId = '',
    keyIds,
    searchValue,
    pageSize,
    pageNumber,
    userId
}) => {

    try {
        let url = apiEndpoints?.relatedBlogs;
        const queryParams = [];
        queryParams.push(`PageSize=${encodeURIComponent(pageSize)}`);
        queryParams.push(`PageNumber=${encodeURIComponent(pageNumber)}`);
        if (userId && userId != 'undefined') {
            queryParams.push(`userId=${encodeURIComponent(userId)}`);
        }

        if (searchValue) {
            queryParams.push(`searchName=${encodeURIComponent(searchValue)}`);
        }

        const categoryIdInt = parseInt(selectedCatgId, 10);

        if (!isNaN(categoryIdInt) && categoryIdInt !== 0) {
            queryParams.push(`categoryId=${encodeURIComponent(categoryIdInt)}`);
        }

        if (keyIds?.length > 0) {
            const subCategoryIdsQuery = keyIds
                .map(id => `keywordIds=${encodeURIComponent(id)}`)
                .join('&');
            queryParams.push(subCategoryIdsQuery);
        }

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        return http.get(url);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};



export const filterAllblogs1 = ({


    selectedCatgId = '',
    keyIds,
    searchValue,
    pageSize,
    pageNumber,
    userId
}) => {

    try {
        let url = apiEndpoints?.relatedBlogs;
        const queryParams = [];

        queryParams.push(`PageSize=${encodeURIComponent(pageSize)}`);
        queryParams.push(`PageNumber=${encodeURIComponent(pageNumber)}`);
        if (userId && userId != 'undefined') {
            queryParams.push(`userId=${encodeURIComponent(userId)}`);
        }

        if (searchValue) {
            queryParams.push(`searchName=${encodeURIComponent(searchValue)}`);
        }

        if (selectedCatgId && selectedCatgId !== 0) {
            queryParams.push(`categoryId=${encodeURIComponent(selectedCatgId)}`);
        }

        if (keyIds?.length > 0) {
            const subCategoryIdsQuery = keyIds
                .map(id => `keywordIds=${encodeURIComponent(id)}`)
                .join('&');
            queryParams.push(subCategoryIdsQuery);
        }

        if (queryParams.length > 0) {
            url += `?${queryParams.join('&')}`;
        }

        return http.get(url);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const sendTimeZone = (userId, timeZone) => {
    try {

        const values = {
            uId: userId,
            timeZone: timeZone
        }

        return http.post(`${apiEndpoints.getTimeZone}`, values);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};

export const sendLanguage = (userId, language) => {
    try {

        const values = {
            uId: userId,
            language: language
        }

        return http.post(`${apiEndpoints.setLanguage}`, values);
    } catch (error) {
        return Promise.reject(error?.response?.data || error);
    }
};



export const blogDetails = async (blogId, userId) => {
    try {
        return http.get(`${apiEndpoints.blogDetail}?blogid=${blogId}&userId=${userId}`);

    } catch (error) {
        return Promise.reject(error.message || error);
    }
};


export const policies = async () => {
    try {
        return http.get(`${apiEndpoints.getContent}`);

    } catch (error) {
        return Promise.reject(error.message || error);
    }
};

export const recomendationId = async (videoId, userId) => {
    try {
        return http.get(`keywords/video/${videoId}/subcategory/user/${userId}`);

    } catch (error) {
        return Promise.reject(error.message || error);
    }
};

export const recomendedVideos = async (userId) => {
    try {
        return http.get(`keywords/user/${userId}/recommended-videos`);

    } catch (error) {
        return Promise.reject(error.message || error);
    }
};


export const blogRecomendationId = async (blogId, userId) => {

    try {
        return http.get(`keywords/blog/${blogId}/category/user/${userId}`);
    } catch (error) {
        return Promise.reject(error.message || error);
    }

};

export const recomendedBlogs = async (userId) => {

    try {
        return http.get(`keywords/user/${userId}/recommended-blogs`);

    } catch (error) {
        return Promise.reject(error.message || error);
    }
};

export const notification = async (id) => {
    try {
        return http.get(`LifeNutritionNotifications/${id}`);
    } catch (error) {
        return Promise.reject(error.message || error);
    }

};